import React from 'react'
import { noop } from 'lodash'
import { GeneralModal as GeneralModalComponent } from '@adc/ui-core'

type GeneralModalProps = {
  close: () => void
  actionInfoText?: string
  preventClose?: boolean
  onError?: (err: unknown) => void
}

export const GeneralModal: React.FC<GeneralModalProps> = ({
  close = () => noop(),
  onError = () => noop(),
  actionInfoText,
  preventClose = false,
  ...rest
}) => {
  const onCloseModal = () => {
    close()
  }

  return (
    <GeneralModalComponent
      open
      onClose={onCloseModal}
      onError={onError}
      {...rest}
    />
  )
}
